export default __webpack_public_path__ + "static/media/Gleaning.56368ae6.png";